var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExclusive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Controls_icon_Flag-2",
    "data-name": "Controls/icon/Flag-2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2355",
    "data-name": "Rectangle 2355",
    width: 38,
    height: 38,
    fill: "none",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3865",
    "data-name": "Path 3865",
    d: "M21.728,50.27a2.062,2.062,0,0,1-.784-.15,2.552,2.552,0,0,1-1.466-2.62V18.061a3.746,3.746,0,0,1,3.69-3.791h16.62a3.746,3.746,0,0,1,3.69,3.791V47.5a2.552,2.552,0,0,1-1.466,2.62,2.44,2.44,0,0,1-2.813-.887L31.627,40.9a.182.182,0,0,0-.3,0l-7.575,8.329A2.729,2.729,0,0,1,21.728,50.27Zm9.75-12.89a3.489,3.489,0,0,1,2.6,1.17L40.125,45.2V18.061a.35.35,0,0,0-.335-.345H23.169a.35.35,0,0,0-.335.345V45.192L28.88,38.55A3.488,3.488,0,0,1,31.478,37.38Z",
    transform: "translate(-12.479 -13.27)",
    fill: "#ffff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusive);
export default __webpack_public_path__ + "static/media/exclusive.04284d9046e309389674f05266c8a239.svg";
export { ForwardRef as ReactComponent };